module.exports = "/_next/static/media/Image-4.6da11d78.png";